"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _httpCore = _interopRequireDefault(require("./httpCore"));

require("./api/addRecords");

require("./api/clearCache");

require("./api/getSubTable");

require("./api/getTable");

require("./api/login");

require("./api/logout");

require("./api/modifyRecords");

require("./api/removeRecords");

require("./api/beforeSaveAdd");

require("./api/beforeSaveModify");

require("./api/uploadFile");

require("./api/moveUpFirst");

require("./api/moveDownLast");

require("./api/moveDownSteps");

require("./api/moveUpSteps");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * 包含所有的 api
 */


var _default = _httpCore.default;
exports.default = _default;